import { MenuItem, Testimonial, Feature, PaymentMethod, Branch } from "./types";

// Import QRIS
import qrisIbnuSina from "./src/assets/qris/qris-ibnu-sina.webp";
import qrisAnduring from "./src/assets/qris/qris-anduring.webp";
import qrisSeberangPadang from "./src/assets/qris/qris-seberang-padang.webp";
import qrisKalawi from "./src/assets/qris/qris-kalawi.webp";
import qrisSiteba from "./src/assets/qris/qris-siteba.webp";
import qrisKampungOlo from "./src/assets/qris/qris-kampung-olo.webp";

import QRIS from "./src/assets/Metode Pembayaran/Logo QRIS.webp";
import BSI from "./src/assets/Metode Pembayaran/BSI.webp";

// Logo Hisana
import logoHisana from "./src/assets/logo/logo-hisana.webp";

export const QRIS_LOGO = QRIS;
export const BSI_LOGO = BSI;
export const LOGO_URL = logoHisana;

export const CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vTKumjwjsptdSA80QBwn-qGC2A-DIYnT8WijlWkHijcJYRlQz2DLwqGiFYD-OLkez9bPyStx_JMoVdK/pub?gid=683740645&single=true&output=csv";

export const urlInfo =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vTF6tTLAnnTKC5MGTwlTrJMZ4ej93FgVYa95oKl3vKi1v1slUdAa4jzSEe5Kd5jwJhKlC35YabRFL8r/pub?gid=86557158&single=true&output=csv";

// Fungsi untuk membersihkan nomor HP agar bisa jadi link WhatsApp
const formatWhatsApp = (phone: string) => {
  const clean = phone.replace(/[^0-9]/g, "");
  return clean.startsWith("0") ? "62" + clean.slice(1) : clean;
};

// Fungsi utama untuk mengambil data dinamis dari Sheets
export const fetchDynamicData = async () => {
  try {
    const response = await fetch(urlInfo);
    const csvText = await response.text();
    const rows = csvText.split("\n").map((row) => row.split(","));

    // Ambil baris kategori 'Cabang'
    const branchRows = rows.filter((row) => row[0] === "Cabang");

    const updatedBranches = BRANCHES.map((branch) => {
      // Mencari baris yang mengandung "SMB 1", "SMB 2", dst sesuai ID branch
      const sheetData = branchRows.find((row) =>
        row[1].includes(`SMB ${branch.id}`),
      );

      if (sheetData) {
        const rawPhone = sheetData[2].trim(); // Mengambil kolom Detail_Informasi (Nomor HP)
        return {
          ...branch,
          whatsapp: rawPhone,
          whatsappLink: `https://wa.me/${formatWhatsApp(rawPhone)}`,
        };
      }
      return branch;
    });

    return updatedBranches;
  } catch (error) {
    console.error("Gagal mengambil data dari Sheets:", error);
    return BRANCHES;
  }
};

export const RESTAURANT_INFO = {
  name: "Hisana Fried Chicken Padang",
  subName: "#BesarDanEnak",
  rating: 4.2,
  reviewsCount: 42,
  priceRange: "Rp 7.000 – 130.500",
  address:
    "Jl. Gajah Mada, Gn. Pangilun, Kec. Padang Utara, Kota Padang, Sumatera Barat 25173",
  plusCode: "39H8+FG Gn. Pangilun, Kota Padang",
  phone: "0821-7460-9521",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Hisana+Fried+Chicken+Ibnu+Sina+Padang",
  whatsappLink: "https://wa.me/6282174609521",
  goFoodLink:
    "https://gofood.co.id/id/padang/restaurant/hisana-fried-chicken-ibnu-sina",
  shopeeFoodLink: "https://shopee.co.id/universal-link/now-food/shop/21000000",
  hours: "11.00 - 22.00",
  fullHours: [
    { day: "Senin", time: "11.00 - 22.00" },
    { day: "Selasa", time: "11.00 - 22.00" },
    { day: "Rabu", time: "11.00 - 22.00" },
    { day: "Kamis", time: "11.00 - 22.00" },
    { day: "Jumat", time: "11.00 - 22.00" },
    { day: "Sabtu", time: "11.00 - 22.00" },
    { day: "Minggu", time: "11.00 - 22.00" },
  ],
  specialHour: "Sangat ramai saat jam makan siang dan sore hari",
  googleSheetWebhook: "",
  socials: {
    instagram: "https://instagram.com/hisanapadangraya",
    facebook: "https://facebook.com/hisanapadang",
    tiktok: "https://tiktok.com/@hisanapadang321",
  },
};

export const INITIAL_REVIEWS: Testimonial[] = [];

export const BRANCHES: Branch[] = [
  {
    id: 1,
    name: "Hisana Fried Chicken Kampung Olo",
    address: "Jl. Kampung Olo (Gajah Mada), Kec. Nanggalo, Kota Padang",
    whatsapp: "082174609521", // Menggunakan nomor pusat sesuai sheet jika belum ada nomor spesifik
    mapsLink: "https://maps.app.goo.gl/p2t3MEEuuW9UWPBEA",
    goFoodLink: "https://gofood.link/a/QZr8UfY",
    shopeeFoodLink: "https://shopee.co.id/now-food/shop/22312365",
    lat: -0.9058595,
    lng: 100.3613858,
  },
  {
    id: 2,
    name: "Hisana Fried Chicken Siteba Raya",
    address: "Jl. Raya Siteba, Surau Gadang, Kec. Nanggalo, Kota Padang",
    whatsapp: "", // Kosong sementara
    mapsLink: "https://maps.app.goo.gl/kWdG8Zs59cirar429",
    goFoodLink: "https://gofood.link/a/QZr9EZf",
    shopeeFoodLink: "https://shopee.co.id/now-food/shop/22312329",
    lat: -0.8990231,
    lng: 100.370503,
  },
  {
    id: 3,
    name: "Hisana Fried Chicken Kalawi",
    address: "Jl. Kalawi, Kec. Kuranji, Kota Padang",
    whatsapp: "082389373681",
    mapsLink: "https://maps.app.goo.gl/sygFWzPPv1Uhmw6v7",
    goFoodLink: "https://gofood.link/a/QZraLZS",
    shopeeFoodLink: "https://shopee.co.id/now-food/shop/22312367",
    lat: -0.9224832,
    lng: 100.3915428,
  },
  {
    id: 4,
    name: "Hisana Fried Chicken Ibnu Sina",
    address:
      "Jl. Gajah Mada (Komp. RS Ibnu Sina), Gn. Pangilun, Kec. Padang Utara",
    whatsapp: "082174609521",
    mapsLink: "https://maps.app.goo.gl/swsGhmoc38S5rdGM9",
    goFoodLink: "https://gofood.link/a/QYh3Njm",
    shopeeFoodLink: "https://shopee.co.id/now-food/shop/22197508",
    lat: -0.9212895,
    lng: 100.3663493,
  },
  {
    id: 5,
    name: "Hisana Fried Chicken M Yunus Anduring",
    address: "Jl. Anduring, Kec. Kuranji, Kota Padang",
    whatsapp: "082173562573",
    mapsLink: "https://maps.app.goo.gl/KSDsQjxs1aarw2as5",
    goFoodLink: "https://gofood.link/a/R33K3rN",
    shopeeFoodLink: "https://shopee.co.id/now-food/shop/22188384",
    lat: -0.9344194,
    lng: 100.3879069,
  },
  {
    id: 6,
    name: "Hisana Fried Chicken Seberang Padang",
    address: "Jl. Seberang Padang, Kec. Padang Selatan, Kota Padang",
    whatsapp: "081239063684",
    mapsLink: "https://maps.app.goo.gl/4StTcFQu4fLSN86Q6",
    goFoodLink: "https://gofood.link/a/R33Kxq1",
    shopeeFoodLink: "https://shopee.co.id/now-food/shop/22302622",
    lat: -0.9569606,
    lng: 100.3749549,
  },
];

export const PAYMENT_METHODS: PaymentMethod[] = [
  {
    id: "qris_all",
    name: "QRIS (Gopay, OVO, ShopeePay)",
    type: "qris",
    provider: "QRIS",
    qrImage: qrisKampungOlo,
    branchQRIS: {
      1: qrisKampungOlo,
      2: qrisSiteba,
      3: qrisKalawi,
      4: qrisIbnuSina,
      5: qrisAnduring,
      6: qrisSeberangPadang,
    },
  },
  {
    id: "bank_bsi",
    name: "Transfer Bank BSI",
    type: "bank",
    provider: "BSI",
    accountNumber: "7296884086",
    accountName: "Hisana Fried Chicken",
    branchAccounts: {
      1: "7296884086",
      2: "7296884124",
      3: "7296884175",
      4: "7296884213",
      5: "7306454352",
      6: "7316369817",
    },
    branchAccountNames: {
      1: "HISANA SMB 1 GAJAH MADA",
      2: "HISANA SMB 2 SITEBA RAYA",
      3: "HISANA SMB 3 KALAWI",
      4: "HISANA SMB 4 IBNU SINA",
      5: "HISANA SMB 5 M YUNUS ANDURING",
      6: "HISANA SMB 6 SEBERANG PADANG",
    },
  },
];

export const FULL_MENU: { category: string; items: MenuItem[] }[] = [];

export const FEATURES: Feature[] = [
  {
    id: 1,
    title: "HALAL",
    description: "Diproses secara syar'i.",
    icon: "Shield",
  },
  {
    id: 2,
    title: "CRISPY",
    description: "Proses pemasakan 170c.",
    icon: "Thermometer",
  },
  {
    id: 3,
    title: "SEGAR",
    description: "Bahan baku terstandar.",
    icon: "Utensils",
  },
  {
    id: 4,
    title: "JUICY",
    description: "Marinasi 12 bumbu rahasia.",
    icon: "CookingPot",
  },
];
